export default "<app-navbar selectedIndex=4></app-navbar>\n<app-main-template [navItems]='navItems' title='RESSOURCES'></app-main-template>"